import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WmsMenu } from '../menu/menu';
import { WmsMenuHeaderTop } from '../menu/menuTop';
import { WmsMenuHeaderBottom } from '../menu/menuBottom';
import { PageDTO } from '@/model/PageDTO';
import { Language } from '@/enums/Language';
import { ContactForm } from "@/components/contact-form/contact-form";
import { BaseComponent } from '../base-component';
import $ from 'jquery'

@Component({
	components: {
		WmsMenu,
		WmsMenuHeaderTop,
		WmsMenuHeaderBottom,
		ContactForm
	}
})

export class WmsLayout extends BaseComponent {
	block = this.$store.componentsPage.blocks.find(b => b.template === 'layout');
	layoutClass = 'container';

	availableLanguages = [
		Language.Cz,
		Language.En
		//Language.Ru
	];

	window = window;

	showMenu: boolean = false;
	showLangMenu: boolean = false;

	@Watch('$route', { deep: true, immediate: true })
	routerOnChange() {
		this.showMenu = false;
		this.layoutClass = this.$store.page && this.$store.page.template === 'empty-page-without-layout' ? '' : 'container';
	}

	showContactForm(event: Event) {
		event.preventDefault();
		this.$modal.show('contact-form');
	}

	switchLang(event: MouseEvent, langId: Language) {
		event.preventDefault();

		//this.$languageServiceObsolete.langId = langId;
		this.$store.setLang(langId);
		//console.log("Language switched to: " + Language[langId]);
	}

	toggleShowLangMenu() {
		this.showLangMenu = !this.showLangMenu;
	}

	mounted() {
		(window as any).showContactFormGlobal = (e: Event) => {
			if (!e) {
				e = window.event;
			}
			this.showContactForm(e);
		}


		$("body").click(function (e) {
			//console.log($(e.target).parent());
			let parent = $(e.target).parent();
			//console.log(parent.attr('class'));

			let canClose = !(parent.hasClass('mm-product') || parent.hasClass('mm-main-item'));

			if (canClose) {
				$(".menu-top-visible").removeClass("menu-top-visible");
			}
		})
	}
}

export default WmsLayout;
